import { FC } from 'react'
import * as styles from 'styles/pages/Styleguide.css'
import { Avatar } from 'components/features/socialFeed/Avatar/Avatar'

export function getRandomLetter () {
  return String.fromCharCode('a'.charCodeAt(0) + Math.floor(Math.random() * 26))
}

export const SGAvatar: FC = () => {
  return (
    <div className={ styles.sgFeed }>
      <div className={ styles.avatarSmall }>
        <Avatar name={ getRandomLetter() } />
      </div>
      <div className={ styles.avatarMedium }>
        <Avatar name={ getRandomLetter() } />
      </div>
      <div className={ styles.avatarBig }>
        <Avatar name={ getRandomLetter() } />
      </div>
    </div>
  )
}
